<template>
  <div justify="center">
    <div id="c-scheduler" class="c-scheduler">
      <div class="c-header" :style="getHeaderStyle">
        <div v-if="headerTitles">
          <div class="c-header__item" :style="getHeaderTitleStyle">
            {{ headerTitles[0] ? headerTitles[0] : "" }}
          </div>
          <div class="c-header__item" :style="getHeaderSubTitleStyle">
            <slot name="headerSubTitle">
              {{ headerTitles[1] ? headerTitles[1] : "" }}
            </slot>
          </div>
        </div>
        <div
          v-else
          class="c-header--left-blank"
          :style="getHeaderLeftBlankStyle"
        />
        <div
          class="c-header__item"
          v-for="headerItem in headerList"
          :style="getHeaderItemStyle"
        >
          <slot name="headerItem" :item="headerItem">
            {{ headerItem }}
          </slot>
        </div>
        <div :style="getHeaderRightBlankStyle" />
      </div>

      <div class="c-content--wrapper" :style="getContentsSize">
        <v-row
          class="c-content"
          v-for="content of contentList"
          align="center"
          justify="start"
        >
          <div
            class="c-content__title"
            :style="getTitleSize(Object.keys(content.subContents).length)"
          >
            <slot name="mainContent" :item="content">
              {{ content.title }}
            </slot>
          </div>
          <div>
            <v-row
              v-for="subContent in content.subContents"
              class="c-content__sub-content--wrapper"
              :style="getSubContentWrapperSize"
              @click="onClickContentRow(subContent)"
            >
              <div
                class="c-content__sub-content__title"
                :style="getSubTitleWidth"
              >
                <v-row
                  align="center"
                  justify="center"
                  style="margin-left: 0px; margin-right: 0px; height: 100%;"
                >
                  <slot name="subContent" :item="subContent">
                    {{ subContent.title }}
                  </slot>
                </v-row>
              </div>
              <div
                class="c-content__sub-content__item--wrapper"
                :style="getSubContentItemWrapperSize"
              >
                <div
                  id="start"
                  class="c-content--guide-line"
                  :style="getStartGuidLineStyle"
                />
                <div
                  id="end"
                  class="c-content--guide-line"
                  :style="getEndGuidLineStyle"
                />
                <template v-for="item in subContent.items">
                  <div
                    v-if="checkItemHasColor(item)"
                    class="c-content__sub-content__item"
                    :style="getItemStyle(item)"
                  >
                    <slot name="contentItem" :item="item"> </slot>
                  </div>
                  <div
                    v-else
                    class="c-content__sub-content__item"
                    :style="getIconDivStyle(item)"
                  >
                    <slot name="contentIcon" :item="item"> </slot>
                  </div>
                </template>
              </div>
            </v-row>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // header props
    headerList: {
      type: Array,
      default: [],
    },
    headerCellHeight: {
      type: Number | String,
      default: 40,
    },
    headerCellWidth: {
      type: Number | String,
      default: 60,
    },
    headerTitles: {
      // [header title, header sub title]
      type: Array,
    },
    ///--- end header props

    contentList: {
      type: Object | Array,
    },

    // style
    titleWidth: {
      type: Number | String,
      default: 100,
    },
    titleHeight: {
      type: Number | String,
      default: 45,
    },
    subTitleWidth: {
      type: Number | String,
      default: 100,
    },

    /// item props
    itemWrapperRowHeight: {
      // item wrapper height
      type: Number | String,
      default: 30,
    },

    itemRowWidth: {
      // item width
      type: Number | String,
      default: 1440, // headerCellWidth * headerList.size
    },
    itemRowHeight: {
      // item height
      type: Number | String,
      default: 14,
    },
    itemRowHeightPadding: {
      type: Number | String,
      default: 15,
    },
    iconHeight: {
      type: Number | String,
      default: 20,
    },

    contentsHeight: {
      type: Number | String,
      default: 600,
    },

    ///---end item props

    guideLine: {
      type: Object,
      default: () => ({
        startLeft: 10,
        endLeft: 40,
        color: "red",
      }),
    },
  },
  data: () => ({
    headerItem: [],

    //props
  }),
  computed: {
    getHeaderStyle() {
      // title 사이즈에 따른 header left padding
      return { width: this.itemRowWidth + 200 + "px" };
    },
    getHeaderLeftBlankStyle() {
      // title 사이즈에 따른 header left blank
      return {
        width: parseInt(this.titleWidth) + parseInt(this.subTitleWidth) + "px",
        height: "40px",
        verticalAlign: "top",
        display: "inline-block",
      };
    },
    getHeaderRightBlankStyle() {
      // title 사이즈에 따른 header right blank
      return { width: "16px", height: "10px", display: "inline-block" };
    },
    getHeaderItemStyle() {
      return {
        width: this.headerCellWidth + "px",
        height: this.headerCellHeight + "px",
        lineHeight: this.headerCellHeight + "px",
      };
    },
    getHeaderTitleStyle() {
      return {
        width: this.titleWidth + "px",
        height: this.headerCellHeight + "px",
        lineHeight: this.headerCellHeight + "px",
      };
    },
    getHeaderSubTitleStyle() {
      return {
        width: this.subTitleWidth + "px",
        height: this.headerCellHeight + "px",
      };
    },
    getContentWrapperSize() {
      // 전체 contents width + scroll bar
      // (-11): zoom out 75% / +17: zoom out 50% / +17: width of scroll bar
      return { backgroundColor: "#f7f7f7" };
    },

    getContentsSize() {
      // 전체 contents height
      return {
        height: this.contentsHeight + "px",
        width: this.itemRowWidth + 200 + "px",
      };
    },
    getTitleWidth() {
      // title width
      return { width: this.titleWidth + "px" };
    },

    getSubContentWrapperSize() {
      // content(row) height
      const height =
        parseInt(this.itemWrapperRowHeight) + this.itemRowHeightPadding;
      return {
        height: height + "px",
        // position: 'absolute',
        // top: '50%',
        // marginTop: (height/2)+'px'
      };
    },
    getSubTitleWidth() {
      // sub title width
      return { width: this.subTitleWidth + "px" };
    },

    getSubContentItemWrapperSize() {
      // content(row) height for wrapper
      return { width: this.itemRowWidth + "px" };
    },

    getStartGuidLineStyle() {
      // start guide line style
      return this.guideLine
        ? {
            height:
              parseInt(this.itemWrapperRowHeight) +
              this.itemRowHeightPadding +
              "px",
            left: this.guideLine.startLeft + "px",
          }
        : { display: "none" };
    },
    getEndGuidLineStyle() {
      // end guide line style
      return this.guideLine
        ? {
            height:
              parseInt(this.itemWrapperRowHeight) +
              this.itemRowHeightPadding +
              "px",
            left: this.guideLine.endLeft + "px",
          }
        : { display: "none" };
    },

    getTitle() {},
    getContents() {},
  },

  methods: {
    onClickContentRow(subContent) {
      this.$emit("onClickContentRow", subContent);
    },
    getHexToAgbColor(hexColor) {
      if (hexColor.indexOf("#") < 0 || hexColor.length !== 7) {
        return null;
      }
      let r = hexColor.substring(1, 3);
      let g = hexColor.substring(3, 5);
      let b = hexColor.substring(5, 7);

      r = parseInt(r, 16) - 30;
      r = r < 0 ? 0 : r;
      g = parseInt(g, 16) - 30;
      g = g < 0 ? 0 : g;
      b = parseInt(b, 16) - 30;
      b = b < 0 ? 0 : b;

      return "rgb(" + r + ", " + g + ", " + b + ")";
    },
    getItemStyle(item) {
      const borderColor = this.getHexToAgbColor(item.color) || item.color;
      const itemHeight = this.itemRowHeight;
      const itemMarginTop = (parseInt(itemHeight) / 2) * -1;
      return {
        backgroundColor: item.color,
        width:
          item.width < this.itemRowWidth
            ? item.width + "px"
            : this.itemRowWidth + "px",
        height: itemHeight + "px",
        left: item.left + "px",
        boxShadow: "inset 0px 0px 2px 1px " + borderColor, //rgba(153, 153, 153, 0.76)'
        // borderRadius: '50px',

        // vertical center
        marginTop: itemMarginTop + "px",
        top: "50%",
      };
    },
    getTitleSize(length) {
      return {
        width: this.titleWidth + "px",
        height: this.titleHeight * length + "px",
      };
    },
    checkItemHasColor(item) {
      return !!item.color;
    },
    getIconDivStyle(item) {
      return {
        left: item.left + "px",
        // vertical center
        top: "25%",
      };
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.c-scheduler {
  background-color: #f7f7f7;
  padding: 0px;
  margin: 0 auto;
  color: black;
  overflow: scroll;

  .c-header {
    font-size: 0.8rem;
    font-weight: 400;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: #f7f7f7;

    .c-header--left-blank {
      position: sticky;
      left: 0;
      background-color: #f7f7f7;
      z-index: 5;
      border-bottom: 1px solid #dce2e5;
      border-right: 1px solid #dce2e5;
    }

    .c-header__item {
      display: inline-block;
      text-align: center;
      padding: 5px 0;
      border-bottom: 1px solid #dce2e5;
      border-right: 1px solid #dce2e5;
    }
  }

  .c-content--wrapper {
  }
  .c-content {
    margin-left: 0px !important;
    margin-right: 0px !important;

    .c-content__title {
      position: sticky;
      left: 0;
      background-color: #f7f7f7;
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #dce2e5;
      border-right: 1px solid #dce2e5;
    }

    .c-content__sub-content__title {
      text-align: center;
      position: sticky;
      left: 100px;
      z-index: 4;
      background-color: #f7f7f7;
      border-right: 1px solid #dce2e5;
    }
    .c-content__sub-content--wrapper {
      margin-left: 0px !important;
      margin-right: 0px !important;
      border-bottom: 1px solid #dce2e5;
      font-size: 14px;
    }

    .c-content__sub-content__item--wrapper {
      position: relative !important;
      border-right: 1px solid #dce2e5;

      .c-content--guide-line {
        border: 1px solid red;
        width: 1px;
        position: absolute;
        background-color: red;
        z-index: 3;
      }
      .c-content__sub-content__item {
        position: absolute !important;
      }
    }
  }
}
</style>
